import React, { Component } from 'react';
import { ListEvents, Create, Mentor } from './graphql.js';
import CsvImportComponent from '../../components/CsvImport';
import {
  adminQuery,
  adminMutation,
  logError,
  toAwsJson,
  parseAwsJson,
  updateInPath
} from '../../../../common/utils';
import { getList } from '../../../common/utils';
import { clone } from 'ramda';


// END config
export default class Teams extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      events: [],
      loading: false
    };

    this.filter = {};
  }
  
  fetchFilterOptions = async () => {
    const data = await getList('listEvents', { query: ListEvents });
    this.setState(s => updateInPath(s, 'events', data));
  }

  handleSave = async (formData, onSuccess) => {
    const data = clone(formData);

    const mentorAttributes = await getList('getMentorAttributes', {
      query: Mentor,
      variables: { userId: data.userId }
    });

    mentorAttributes.forEach(({ Name, Value }) => {
      data.mentor[Name] = Value;
    });

    data.mentor = JSON.stringify(data.mentor);
    data.members = toAwsJson(data.members);

    console.log(data);

    adminMutation(
      data,
      [],
      Create,
      () => { onSuccess(); }
    );
  }

  componentDidMount = () => {
    this.fetchFilterOptions();
  }

  render() {
    const { data, events, loading } = this.state;
    
    return (
      <CsvImportComponent
        events={events}
        onSave={this.handleSave}
        loading={loading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/containers/CsvImport/index.js